// @ts-strict-ignore
import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Stack,
  BodyText,
  HeaderText,
} from '../../../../ui';
import { RatingTagInfo } from '../../../../../modules/provider/reviews';
import analytics from '../../../../../modules/analytics';
import RatingStars from '../../../../RatingStars';
import ReviewTagsModal from './ReviewTagsModal';
import useMount from '../../../../../hooks/useMount';

export const ReviewTagCollection = ({
  providerId,
  ratingTagInfoArray,
  reviewCount,
  avgRating,
  renderReviewList,
  onTagPress,
}: {
  providerId: number;
  reviewCount: number;
  avgRating: number;
  ratingTagInfoArray: RatingTagInfo[];
  renderReviewList: () => React.ReactNode;
  onTagPress: (tag: RatingTagInfo) => void;
}) => {
  useMount(() => {
    analytics.track('client_rating_tags_list_loaded', {
      provider_id: providerId,
      rating_tag_list: ratingTagInfoArray,
    });
  });

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [selectedTag, setSelectedTag] = useState<RatingTagInfo | null>(null);
  const handleTagPress = (tag: RatingTagInfo) => {
    setSelectedTag(tag);
    setModalOpen(true);
    onTagPress(tag);
    analytics.track('client_ratings_tag_clicked_modal_opened', {
      provider_id: providerId,
      selected_tag: tag.value,
      selected_tag_group: tag.group,
      selected_tag_count: tag.count,
    });
  };
  const handleModalClose = () => {
    setModalOpen(false);
    analytics.track('client_ratings_tag_clicked_modal_closed', {
      provider_id: providerId,
      selected_tag: selectedTag.value,
      selected_tag_group: selectedTag.group,
      selected_tag_count: selectedTag.count,
    });
    onTagPress(null);
  };

  return (
    <Stack
      space={4}
      testID="review-tag-collection"
      paddingTop={4}
      paddingX={8}
    >
      <Stack paddingY={12}>
        <HeaderText level={2}>Client Reviews</HeaderText>
        <Box paddingTop={8}>
          <RatingStars
            ratingStars={avgRating}
            ratingsCount={reviewCount}
            size={30}
          />
        </Box>
      </Stack>
      <Box
        borderStyle="solid"
        borderTopWidth={1}
        borderTopColor={colors.lightGrey}
        paddingY={12}
      >
        <Box paddingBottom={12} paddingTop={4}>
          <BodyText weight="bold">Read reviews that mention</BodyText>
        </Box>
        <Inline
          justifyContent="flex-start"
          flexWrap="wrap"
          alignItems="center"
          space={4}
        >
          {ratingTagInfoArray.map(item => (
            <TouchableOpacity onPress={() => handleTagPress(item)} key={`${item.value}-${item.group}`}>
              <Box paddingRight={8} paddingY={4}>
                <Box
                  color={colors.whiteWash}
                  paddingX={8}
                  paddingY={4}
                  style={{ boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)' }}
                  borderRadius={5}
                >
                  <BodyText>{item.value}<BodyText color={colors.silver}> {' '}{item.count} </BodyText></BodyText>
                </Box>
              </Box>
            </TouchableOpacity>
          ))}
        </Inline>
      </Box>
      {modalOpen && (
        <ReviewTagsModal
          selectedTag={selectedTag}
          onRequestClose={handleModalClose}
          renderReviewList={renderReviewList}
        />
      )}
    </Stack>
  );
};

export default ReviewTagCollection;
